import { Box, Typography } from "@material-ui/core";
import { ButtonPlus, Header } from "../../shared/Style/Style";

export const BundlesStorageHeader = ({
    onOpenModal,
}) => {
  return (
    <>
      <Header>Бібліотека моделей бандлів</Header>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="baseline"
        my={6}
      >
        <Typography
          variant="body2"
          color="textSecondary"
          style={{ maxWidth: "540px" }}
        >
          Сховище бандлів з маніфестами для Експериментів та Інтерактивних
          вправ. Мовні файли підвантажуються окремо при публікації контенту
        </Typography>
        <ButtonPlus
          variant="contained"
          disabled={false}
          onClick={onOpenModal}
        >
          Додати
        </ButtonPlus>
      </Box>
    </>
  );
};
